import {
	trigger,
	style,
	transition,
	animate
} from '@angular/animations';

export const simpleTransitions = [
	trigger('appearAnimation', [
		transition('void => *', [
			style({ opacity: 0, height: 0 }),
			animate('300ms cubic-bezier(0.0, 0.0, 0.2, 1)', style({ opacity: '*', height: '*' }))
		]),
		transition('* => void', [
			style({ opacity: '*', height: '*' }),
			animate('300ms cubic-bezier(0.4, 0.0, 1, 1)', style({ opacity: 0, height: 0 }))
		])
	])
];
